import React, { useRef, useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { API_URL } from "../../../../constants/index";
import { Table } from "react-bootstrap";
import moment from "moment";
import LeadCreated from "./components/LeadCreated";
import { FaEnvelope } from "react-icons/fa";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import HTMLComponent from "../../../../components/HtmlComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
const getHistoryStatus = (round, status) => {
  if (!round) return status;
  const r = round.toLowerCase();
  const s = status ? status.toLowerCase() : '';
  
  let prefix = '';
  if (r.includes('round 1') || r.includes('tech 1') || r.includes('r1')) {
    prefix = 'R1';
  } else if (r.includes('round 2') || r.includes('tech 2') || r.includes('r2')) {
    prefix = 'R2';
  } else if (r.includes('round 3') || r.includes('tech 3') || r.includes('r3')) {
    prefix = 'R3';
  } else if (r.includes('hr')) {
    prefix = 'HR';
  } else {
    prefix = round;
  }
  
  if (s.includes('reject')) {
    return `${prefix} Reject`;
  }
  if (s.includes('select') || s.includes('accept')) {
    return `${prefix} Selected`;
  }
  return `${prefix} Scheduled`;
};

const CandidateHistoryView = () => {
  const { id } = useParams();
  const [candidateData, setCandidateData] = useState([]);
  const [offerLetterDetail, setOfferLetterDetail] = useState([]);
  const [OfferLetterData, setOfferLetterData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [offerParameters, setOfferParameters] = useState({});
  const [rejectemailModal, setRejectemailModal] = useState(false);
  const [FeedbackModal, setFeedbackModal] = useState(false);
  const [OfferLetterModal, setOfferLetterModal] = useState(false);
  const [interviewData, setInterviewData] = useState([]);
  const [selectedInterviewer, setSelectedInterviewer] = useState("");
  const [interviewDate, setInterviewDate] = useState("");
  const [candidateStatus, setCandidateStatus] = useState("");
  const [selectedRound, setSelectedRound] = useState("");
  const [skills, setSkills] = useState([]);
  const modalRef = useRef(null);
  const initialFormData = {
    JobTitle: "",
    AppliedDate: "",
    FullName: "",
    Email: "",
    MobileNo: "",
    CurrentStatus: "",
    Gender: "",
    DateOfBirth: "",
    MobileNo1: "",
    ExpectedJoiningDate: "",
    CurrentCompanyName: "",
    CurrentLocation: "",
    CurrentExperienceInYears: "",
    CurrentRelevantExperienceInYears: "",
    CurrentCTC: "",
    ExpectedCTC: "",
    CandidateReferralType: "",
    ResumePath: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [leadData, setLeadData] = useState({
    // job_title: '',
    // FirstName: '',
    // LastName: '',
    // EmailID: '',
    // MobileNo: '',
    // CurrentCompanyName: ''
  });

  const handleEnvelopeClick = () => {
    setRejectemailModal(true);
  };

  const closeModal = () => {
    setRejectemailModal(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        handleCloseModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [modalRef]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Candidate History"));
  }, []);

  const fetchDataAndTableData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}candidate-history/${id}`
      );
      if (response.status === 200) {
        const formattedData = {};
        const { candidatedetails } = response.data;
        if (candidatedetails && candidatedetails.length > 0) {
          const {
            JobTitle,
            FullName,
            FirstName,
            Email,
            MobileNo,
            Gender,
            DateOfBirth,
            MobileNo1,
            ExpectedJoiningDate,
            CurrentCompanyName,
            CurrentLocation,
            CurrentExperienceInYears,
            CurrentRelevantExperienceInYears,
            CurrentCTC,
            ExpectedCTC,
            CandidateReferralType,
            CurrentStatus,
            CreatedByName,
            AppliedDate,
            LeadCreatedDate,
            LeadCreatedBy,
            LeadID,
            OfferLetterID,
          } = candidatedetails[0] || {};
          setFormData({
            JobTitle,
            FullName,
            Email,
            MobileNo,
            CurrentStatus,
            Gender,
            DateOfBirth,
            MobileNo1,
            ExpectedJoiningDate,
            CurrentCompanyName,
            CurrentLocation,
            CurrentExperienceInYears,
            CurrentRelevantExperienceInYears,
            CurrentCTC,
            ExpectedCTC,
            CandidateReferralType,
            CreatedByName,
            AppliedDate,
            LeadCreatedDate,
            LeadCreatedBy,
            LeadID,
            OfferLetterID,
          });

          // Process offer letters
          const offerLetters = candidatedetails.reduce((acc, item) => {
            if (item.OfferLetterID && !acc[item.OfferLetterID]) {
              acc[item.OfferLetterID] = {
                OfferLetterID: item.OfferLetterID,
                OfferLetterSendDate: item.OfferLetterSendDate,
                OfferLetterSenderName: item.OfferLetterSenderName,
                OfferLetterStatus: item.CurrentStatus,
              };
            }
            return acc;
          }, {});

          // Set offer letters data
          setOfferLetterData(Object.values(offerLetters));

          // Handle first offer letter status
          if (Object.keys(offerLetters).length > 0) {
            await handleOfferLetterStatus(Object.keys(offerLetters)[0]);
          }

          // Pass LeadID to fetchLeadCandidate
          await fetchLeadCandidate(LeadID);

          // Process interview data
          candidatedetails.forEach((header) => {
            const interviewID = header.InterviewID;
            if (!formattedData[interviewID]) {
              formattedData[interviewID] = {
                InterviewID: interviewID,
                AppliedDate: header.AppliedDate,
                InterviewDate: header.InterviewDate,
                INFInterviewerName: header.INFInterviewerName,
                InfCreatedDate: header.InfCreatedDate,
                Round: header.ROUND,
                InterviewStatus: header.InterviewStatus,
                SuitableForPosition: header.SuitableForPosition,
              };
            }
          });
          setInterviewData(Object.values(formattedData));
        } else {
          console.error("No candidate details found.");
        }
      } else {
        console.error(
          "Failed to fetch data. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // lead candidate details
  const fetchLeadCandidate = async (LeadID) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}leadcandidate/${LeadID}`
      );
      if (response.status === 200) {
        const {
          JobTitle,
          AppliedDate,
          FirstName,
          LastName,
          Gender_020,
          EmailID,
          MobileNo,
          CurrentCompanyName,
          CurrentPosition,
          CurrentExperienceInYears,
          CurrentRelevantExperienceInYears,
          Qualifications,
          CurrentCTC,
          ExpectedCTC,
          ProjectExamples,
          NoticePeriod,
          CurrentLocation,
          PreferredLocation,
          ReasonForChange,
          DateOfBirth,
          AreaDashboard,
          AreaArchitecture,
          AreaSDK,
          AreaReport,
          AreaAdministration,
          AreaOtherSkill,
          LeadCandidateStatus_189,
          LeadID,
          ResumePath,
          IntroduceYourself,
          Accent,
          OralSkills,
          ReferralNote,
          WillingToTravel,
          ProjectOtherDesc,
          CandidateReferralType_174,
          MobileNo1,
        } = response?.data?.candidate[0] || {};
        // Set JobTitle to the state
        setLeadData((prevState) => ({
          ...prevState,
          MobileNo1: MobileNo1,
          CandidateReferralType_174: CandidateReferralType_174,
          IntroduceYourself: IntroduceYourself,
          ProjectOtherDesc: ProjectOtherDesc,
          Accent: Accent,
          OralSkills: OralSkills,
          ReferralNote: ReferralNote,
          WillingToTravel: WillingToTravel,
          job_title: JobTitle,
          AppliedDate: AppliedDate,
          FirstName: FirstName,
          LastName: LastName,
          Gender_020: Gender_020,
          EmailID: EmailID,
          MobileNo: MobileNo,
          CurrentCompanyName: CurrentCompanyName,
          CurrentPosition: CurrentPosition,
          CurrentExperienceInYears: CurrentExperienceInYears,
          CurrentRelevantExperienceInYears: CurrentRelevantExperienceInYears,
          Qualifications: Qualifications,
          ProjectExamples: ProjectExamples,
          CurrentCTC: CurrentCTC,
          ExpectedCTC: ExpectedCTC,
          NoticePeriod: NoticePeriod,
          CurrentLocation: CurrentLocation,
          PreferredLocation: PreferredLocation,
          ReasonForChange: ReasonForChange,
          DateOfBirth: DateOfBirth,
          AreaDashboard: AreaDashboard,
          AreaArchitecture: AreaArchitecture,
          AreaSDK: AreaSDK,
          AreaReport: AreaReport,
          AreaAdministration: AreaAdministration,
          AreaOtherSkill: AreaOtherSkill,
          LeadCandidateStatus_189: LeadCandidateStatus_189,
          LeadID: LeadID,
          ResumePath: ResumePath,
        }));
      }
    } catch (error) {
      console.error("Error fetching lead candidate:", error);
    }
  };

  // feedback form

  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleFeedback = async (
    interviewID,
    interviewerName,
    interviewerDate,
    interviewerStatus,
    roundName
  ) => {
    setFeedbackModal(true);
    setSelectedInterviewer(interviewerName);
    setInterviewDate(interviewerDate);
    setCandidateStatus(interviewerStatus);
    setSelectedRound(roundName);
    try {
      const response = await GetServiceCaller(
        `${API_URL}feedback/${interviewID}`
      );
      setCandidateData(response.data.candidate);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataAndTableData(id);
      fetchLeadCandidate(id);
    }
  }, [id]);

  const handleOfferLetterStatus = async (OfferLetterID) => {
    // const handleOfferLetterStatus = async () => {
    setOfferLetterModal(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}offerletter/${OfferLetterID}`
      );
      // const response = await axios.get(`${API_URL}offerletter/${333}`);
      setOfferLetterDetail(response?.data?.offerletter[0]);
      setOfferParameters(response?.data?.offerParameter);
    } catch (error) {
      console.error("Error fetching offer letter data:", error);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFeedbackModal(false);
    setOfferLetterModal(false);
  };

  let offerLetterCount = 1;
  const offerLetterStartIndex = interviewData.length + 2;

  const displayableKeys = [
    "#emailbasicAmount#",
    "#emailHRA#",
    "#emailSplAllow#",
    "#emailConvAllow#",
    "#emailLTA#",
    "#emailNPS#",
    "#emailGrossSalary#",
    "#emailPF(Monthly)#",
    "#emailLeaveEncashment#",
    "#AnnualPerformanceBonus#",
    "#emailGratuity#",
    "#emailMediclaimInsurance#",
    "#CTC#",
  ];

  const annualKeys = {
    "#emailbasicAmount#": "#emailAnnualBasicAmount#",
    "#emailHRA#": "#emailAnnualHRA#",
    "#emailSplAllow#": "#emailAnnualSplAllow#",
    "#emailConvAllow#": "#emailAnnualConvAllow#",
    "#emailLTA#": "#emailAnnualLTA#",
    "#emailGrossSalary#": "#emailAnnualGrossSalary#",
    "#emailGratuity#": "#emailAnnualGratuity#",
    "#emailPF(Monthly)#": "#emailAnnualEPF#",
    "#emailNPS#": "#emailAnnualNPS#",
  };
  // const formatKey = (key) => {
  //     return key
  //         .replace(/#/g, '')
  //         .replace(/email/g, '')
  //         .replace(/Word/g, '')
  //         .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize the first letter of each word
  // };

  const formatKey = (key) => {
    switch (key) {
      case "#emailbasicAmount#":
        return "Basic Pay";
      case "#emailHRA#":
        return "House Rent Allowance";
      case "#emailSplAllow#":
        return "Professional Development Allowance";
      case "#emailConvAllow#":
        return "Conveyance Allowance";
      case "#emailLTA#":
        return "Leave Travel Allowance";
      case "#emailNPS#":
        return "NPS";
      case "#emailGrossSalary#":
        return "Gross Salary";
      case "#emailPF(Monthly)#":
        return "EPF (Employer PF)";
      case "#emailLeaveEncashment#":
        return "Leave With Wages";
      case "#AnnualPerformanceBonus#":
        return "Annual Performance Bonus";
      case "#emailGratuity#":
        return "Gratuity*";
      case "#emailMediclaimInsurance#":
        return "Mediclaim Insurance";
      case "#CTC#":
        return "TOTAL CTC";
      default:
        return key;
    }
  };

  function formatIndianNumber(number) {
    if (number === null || number === undefined) return "";

    const numParts = number.toString().split(".");
    let integerPart = numParts[0];
    const decimalPart = numParts.length > 1 ? "." + numParts[1] : "";

    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    if (otherDigits !== "") {
      integerPart =
        otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        lastThreeDigits;
    }

    return integerPart + decimalPart;
  }

  const sendRejectMail = async (id) => {
    const DataForm = {
      FirstName: leadData.FirstName,
      Email: leadData.EmailID,
    };
    try {
      const response = await PostServiceCaller(
        `${API_URL}send-reject/${id}`,
        DataForm,
        "post"
      );
      setRejectemailModal(false);
      toast.success("Rejection email sent successfully!");
    } catch (error) {
      console.error("Error posting form data:", error);
      toast.error("Failed to send rejection email.");
    }
  };

  const offerLetterArray = Array.isArray(offerLetterDetail)
    ? offerLetterDetail
    : [offerLetterDetail];

  const suitablePosition = interviewData.find(
    (interview) => interview.SuitableForPosition
  )?.SuitableForPosition;

  const tableRef = useRef(null);

  const handleDownloadPDF = () => {
    const input = tableRef.current;

    // Clone and style table for better rendering
    const tableClone = input.cloneNode(true);
    const allElements = tableClone.querySelectorAll("*");
    allElements.forEach((el) => {
      el.style.fontWeight = "300";
      el.style.fontFamily = "Arial, sans-serif";
      if (el.tagName === "TD" || el.tagName === "TH") {
        el.style.padding = "4px 8px";
      }
    });

    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.left = "-9999px";
    tempContainer.style.width = "210mm"; // A4 width
    document.body.appendChild(tempContainer);
    tempContainer.appendChild(tableClone);

    html2canvas(tableClone, {
      scale: 3, // Higher scale = sharper image (up to 2MB)
      logging: false,
      useCORS: true,
      backgroundColor: "#FFFFFF",
      windowHeight: tableClone.scrollHeight + 50,
    }).then((canvas) => {
      document.body.removeChild(tempContainer);

      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true,
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = pageWidth - 20;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let position = 10;
      let heightLeft = imgHeight;

      // First page
      pdf.addImage(
        canvas,
        "JPEG",
        10,
        position,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      heightLeft -= pageHeight - 20;

      // More pages if needed
      while (heightLeft > 0) {
        position = heightLeft - imgHeight + 10;
        pdf.addPage();
        pdf.addImage(
          canvas,
          "JPEG",
          10,
          position,
          imgWidth,
          imgHeight,
          undefined,
          "FAST"
        );
        heightLeft -= pageHeight - 20;
      }

      const pdfBlob = pdf.output("blob");
      const sizeMB = pdfBlob.size / (1024 * 1024);

      if (sizeMB <= 5) {
        pdf.save("Interview_Feedback_Details.pdf");
      } else {
        toast.error(
          `PDF too large: ${sizeMB.toFixed(2)} MB. Please reduce content.`
        );
      }
    });
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Form>
              <div className="row row-flex">
                <div className="col-md-6 flex-col">
                  <div className="card">
                    <div class="card-header">
                      <h5 className="subheading">Job & Candidate Details</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <dt className="">Job Title</dt>
                          <dd className="">{formData.JobTitle}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Applied Date</dt>
                          <dd className="">
                            {formData.AppliedDate
                              ? moment(formData.AppliedDate).format(
                                  "DD-MMM-YYYY"
                                )
                              : ""}
                          </dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Name</dt>
                          <dd className="">{formData.FullName}</dd>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <dt className="">Gender</dt>
                          <dd className="mb-0">{formData.Gender}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">DOB</dt>
                          <dd className="">
                            {formData.DateOfBirth
                              ? moment(formData.DateOfBirth).format(
                                  "DD-MMM-YYYY"
                                )
                              : ""}
                          </dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Contact No</dt>
                          <dd className="">{formData.MobileNo}</dd>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <dl className="">
                            <dt className="">Alternate Contact No</dt>
                            <dd className="">{formData.MobileNo1}</dd>
                          </dl>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Current Status</dt>
                          <dd className="">{formData.CurrentStatus}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Exp. DOJ</dt>
                          <dd className="">
                            {formData.ExpectedJoiningDate
                              ? moment(formData.ExpectedJoiningDate).format(
                                  "DD-MMM-YYYY"
                                )
                              : ""}
                          </dd>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <dt className="">Email</dt>
                          <dd className="">{formData.Email}</dd>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Company Details */}
                <div className="col-md-6">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="subheading">Employment Details</h5>
                    </div>

                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-4">
                          <dt className="">Company Name</dt>
                          <dd className="">{formData.CurrentCompanyName}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Current Location</dt>
                          <dd className="">{formData.CurrentLocation}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Exp. in yrs</dt>
                          <dd className="">
                            {formData.CurrentExperienceInYears}
                          </dd>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-4">
                          <dt className="">Rel. Exp. in yrs</dt>
                          <dd className="">
                            {formData.CurrentRelevantExperienceInYears}
                          </dd>
                        </div>

                        <div className="col-md-4">
                          <dt className="">CTC (LPA)</dt>
                          <dd className="">{formData.CurrentCTC}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">ECTC (LPA)</dt>
                          <dd className="">{formData.ExpectedCTC}</dd>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-4">
                          <dt className="">Source</dt>
                          <dd className="">{formData.CandidateReferralType}</dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Other</dt>
                          <dd className=""></dd>
                        </div>
                        <div className="col-md-4">
                          <dt className="">Resume</dt>
                          <dd className="">{leadData.ResumePath}</dd>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 mt-2">
                    <h5>
                      <strong>History</strong>
                    </h5>
                  </div>
                  <hr className="new5" />
                  <div className="p-0 m-0">
                    <div className="box-body table-responsive">
                      <Table striped bordered hover>
                        <thead id="thcolor" className="text-center">
                          <tr>
                            <th>Sr. No.</th>
                            <th>Date</th>
                            <th>Process</th>
                            <th>
                              Interviewer / Created By / <br />
                              Offer Letter Sender
                            </th>
                            <th>Round</th>
                            <th>Status</th>
                            <th>Rejection Mail</th>
                            <th>Feedback Submission Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="text-center border-bottom">
                          {formData.LeadID && (
                            <tr>
                              <td>1</td>
                              <td>
                                {moment(formData.LeadCreatedDate).format(
                                  "DD-MMM-YYYY"
                                )}
                              </td>
                              <td className="text-start">Lead Created</td>
                              <td className="text-start">
                                {formData.LeadCreatedBy}
                              </td>
                              <td className="text-start"></td>
                              <td className="text-start">Screening Pending</td>
                              <td className="text-start"></td>
                              <td className="text-start"></td>
                              <td>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      View Candidate Details
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    className="bi bi-eye-fill"
                                    onClick={handleIconClick}
                                  ></i>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td>{formData.LeadID ? 2 : 1}</td>
                            <td>
                              {moment(formData.AppliedDate).format(
                                "DD-MMM-YYYY"
                              )}
                            </td>
                            <td className="text-start">Candidate Created</td>
                            <td className="text-start">
                              {formData.CreatedByName}
                            </td>
                            <td className="text-start"></td>
                            <td className="text-start">Screening Pending</td>
                            <td className="text-start"></td>
                            <td className="text-start"></td>
                            <td>&#8203;</td>
                          </tr>

                          {interviewData.map((interview, index) => {
                            // const interviewDate = new Date(interview.InterviewDate);
                            // const formattedDate = `${interviewDate.getDate()}-${interviewDate.getMonth() + 1}-${interviewDate.getFullYear()}`;
                            const srNo = formData.LeadID
                              ? index + 3
                              : index + 2;
                            return (
                              <tr key={interview.InterviewID}>
                                <td>{srNo}</td>
                                <td>
                                  {moment(interview.InterviewDate).format(
                                    "DD-MMM-YYYY"
                                  )}
                                </td>
                                <td className="text-start">
                                  Interview-{index + 1}
                                </td>
                                <td className="text-start">
                                  {interview.INFInterviewerName}
                                </td>
                                <td className="text-start">
                                  {interview.Round}
                                </td>
                                 <td className="text-start">
                                   {getHistoryStatus(interview.Round, interview.InterviewStatus)}
                                 </td>
                                <td>
                                  {interview.InterviewStatus === "Reject" ? (
                                    <FaEnvelope
                                      onClick={() => handleEnvelopeClick()}
                                      className="envelope-icon"
                                    />
                                  ) : null}
                                </td>
                                <td>{interview.InfCreatedDate}</td>
                                <td>
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                      <Tooltip id="tooltip-bottom">
                                        View FeedBack
                                      </Tooltip>
                                    }
                                  >
                                    <i
                                      className="bi bi-eye-fill"
                                      onClick={() =>
                                        handleFeedback(
                                          interview.InterviewID,
                                          interview.INFInterviewerName,
                                          interview.InterviewDate,
                                          interview.InterviewStatus,
                                          interview.Round
                                        )
                                      }
                                    ></i>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            );
                          })}

                          {offerLetterArray.map((item, index) => (
                            <tr key={item.ID}>
                              <td>{interviewData.length + index + 3}</td>
                              <td>
                                {moment(item.OfferLetterSendDate).format(
                                  "DD-MMM-YYYY"
                                )}
                              </td>
                              <td className="text-start">{`OfferLetter-${
                                index + 1
                              }`}</td>
                              <td className="text-start">
                                {item.OfferLetterSenderName}
                              </td>
                              <td className="text-start">&#8203;</td>
                              <td className="text-start">
                                {item.OfferLetterStatus}
                              </td>
                              <td className="text-start">&#8203;</td>
                              <td>
                                {["Select", "Select for next round"].includes(
                                  item.OfferLetterStatus
                                )
                                  ? item.InfCreatedDate
                                  : ""}
                              </td>
                              <td>
                                <OverlayTrigger
                                  placement="bottom"
                                  overlay={
                                    <Tooltip id="tooltip-bottom">
                                      Offer Letter Details
                                    </Tooltip>
                                  }
                                >
                                  <i
                                    className="bi bi-eye-fill"
                                    onClick={() =>
                                      handleOfferLetterStatus(item.ID)
                                    }
                                  ></i>
                                </OverlayTrigger>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {showModal && (
                        <div
                          className="modal"
                          tabIndex="-1"
                          role="dialog"
                          style={{
                            display: "block",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                          }}
                        >
                          <div
                            ref={modalRef}
                            className="modal-dialog modal-lg"
                            role="document"
                          >
                            <div className="modal-content custom-modal-content">
                              <div
                                className="modal-header"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  borderBottom: "1px solid #f0f0f0",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "8px 8px 0 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "600",
                                    color: "#27568B",
                                    margin: "0",
                                  }}
                                >
                                  Candidate Details
                                </p>
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#000",
                                    padding: "4px",
                                    borderRadius: "4px",
                                    transition: "all 0.2s",
                                    lineHeight: "1",
                                  }}
                                  onClick={handleCloseModal}
                                  aria-label="Close"
                                >
                                  <i class="bi bi-x-lg"></i>
                                </button>
                              </div>
                              <div className="modal-body p-0">
                                <LeadCreated
                                  leadData={leadData}
                                  AppliedDate={leadData.AppliedDate}
                                  FirstName={leadData.FirstName}
                                  LastName={leadData.LastName}
                                  EmailID={leadData.EmailID}
                                  CurrentCompanyName={
                                    leadData.CurrentCompanyName
                                  }
                                  CurrentPosition={leadData.CurrentPosition}
                                  CurrentExperienceInYears={
                                    leadData.CurrentExperienceInYears
                                  }
                                  CurrentRelevantExperienceInYears={
                                    leadData.CurrentRelevantExperienceInYears
                                  }
                                  Qualifications={leadData.Qualifications}
                                  CurrentCTC={leadData.CurrentCTC}
                                  ExpectedCTC={leadData.ExpectedCTC}
                                  NoticePeriod={leadData.NoticePeriod}
                                  CurrentLocation={leadData.CurrentLocation}
                                  PreferredLocation={leadData.PreferredLocation}
                                  DateOfBirth={leadData.DateOfBirth}
                                  Gender_020={leadData.Gender_020}
                                />
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="custom-btn"
                                  onClick={handleCloseModal}
                                >
                                  OK
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {FeedbackModal && (
                        <div
                          className="modal"
                          tabIndex="-1"
                          role="dialog"
                          style={{
                            display: "block",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                          }}
                        >
                          <div
                            ref={modalRef}
                            className="modal-dialog modal-lg"
                            role="document"
                          >
                            <div className="modal-content custom-modal-content">
                              <div
                                className="modal-header"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  borderBottom: "1px solid #f0f0f0",
                                  backgroundColor: "#f8f9fa",
                                  borderRadius: "8px 8px 0 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: "600",
                                    color: "#27568B",
                                    margin: "0",
                                  }}
                                >
                                  Interview Feedback Details
                                </p>
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#000",
                                    padding: "4px",
                                    borderRadius: "4px",
                                    transition: "all 0.2s",
                                    lineHeight: "1",
                                  }}
                                  onClick={handleCloseModal}
                                  aria-label="Close"
                                >
                                  <i class="bi bi-x-lg"></i>
                                </button>
                              </div>
                              <div className=" text-end">
                                {" "}
                                <button
                                  type="button"
                                  variant="success"
                                  className="me-3 mt-2 custom-btn"
                                  onClick={handleDownloadPDF}
                                >
                                  Export as PDF
                                </button>
                              </div>
                              <div className="modal-body" ref={tableRef}>
                                <div className="box-body table-responsive">
                                  <div className="d-flex gap-5 mb-3">
                                    <h6>
                                      Interviewer Name:{" "}
                                      <b>{selectedInterviewer}</b>
                                    </h6>
                                    <h6>
                                      Round: <b>{selectedRound}</b>
                                    </h6>
                                    {/* <h6>
                                      Status: <b>{candidateStatus}</b>
                                    </h6> */}
                                    <h6>
                                      Date:{" "}
                                      <b>
                                        {moment(interviewDate).format(
                                          "DD-MMM-YYYY"
                                        )}
                                      </b>
                                    </h6>
                                  </div>
                                  <Table striped bordered hover>
                                    <thead id="thcolor" className="text-center">
                                      <tr>
                                        <th>Sr. No.</th>
                                        <th>Category</th>
                                        <th>Name</th>
                                        <th>Rating Out of 5</th>
                                        <th>Comment</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {candidateData.map((item, index) => (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>{item.GroupCategoryLabel}</td>
                                          <td>
                                            {item.Skills
                                              ? item.Skills.replace(/<br>/g, "")
                                                  .split("\n")
                                                  .map((skill, i) => (
                                                    <div key={i}>{skill}</div>
                                                  ))
                                              : ""}
                                          </td>
                                          <td>{item.Rating}</td>
                                          <td>
                                            <HTMLComponent
                                              html={item.Comment}
                                            />
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <h6 className="fw-bold">
                                        Suitable For Next Round
                                        {suitablePosition && (
                                          <tr>
                                            <td className="text-start">
                                              {suitablePosition}
                                            </td>
                                          </tr>
                                        )}
                                      </h6>
                                    </div>

                                    <div className="col-sm-4">
                                      <dl className="row justify-content-center ">
                                        <dt className="col-6 text-end">
                                          OverAll Rating
                                        </dt>
                                        <dd className="col-6 text-start">
                                          {candidateData.reduce(
                                            (total, item) =>
                                              total + parseInt(item.Rating),
                                            0
                                          )}
                                          /25
                                        </dd>
                                      </dl>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="custom-btn"
                                  onClick={handleCloseModal}
                                >
                                  OK
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="">
                  <div className="text-end mt-1">
                    <div>
                      <div
                        className="cancel-btn"
                        onClick={() =>
                          (window.location.href = "/candidate-history")
                        }
                      >
                        Cancel
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {OfferLetterModal && (
        <div
          className="modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        >
          <div
            ref={modalRef}
            className="modal-dialog modal-md modal-dialog-centered"
            role="document"
          >
            <div className="modal-content feedback-modal-content">
              <div
                className="modal-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderBottom: "1px solid #f0f0f0",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px 8px 0 0",
                }}
              >
                <p
                  style={{
                    fontSize: "20px",
                    fontWeight: "600",
                    color: "#27568B",
                    margin: "0",
                  }}
                >
                  Offer Letter Details
                </p>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#000",
                    padding: "4px",
                    borderRadius: "4px",
                    transition: "all 0.2s",
                    lineHeight: "1",
                  }}
                  onClick={handleCloseModal}
                  aria-label="Close"
                >
                  <i class="bi bi-x-lg"></i>
                </button>
              </div>
              <div className="modal-body">
                <div className="container-fluid">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <dl className="col-md-4">
                          <dt>Candidate</dt>
                          <dd>{offerLetterDetail.FullName}</dd>
                        </dl>
                        <dl className="col-md-4">
                          <dt>Sender</dt>
                          <dd>{offerLetterDetail.OfferLetterSenderName}</dd>
                        </dl>
                        <dl className="col-md-4">
                          <dt>Offer Send Date</dt>
                          <dd>
                            {moment(
                              offerLetterDetail.OfferLetterSendDate
                            ).format("DD-MMM-YYYY")}
                          </dd>
                        </dl>
                      </div>

                      <div className="row">
                        <dl className="col-md-4">
                          <dt>Offer Expiry Date</dt>
                          <dd>
                            {moment(
                              offerLetterDetail.OfferLetterExpiryDate
                            ).format("DD-MMM-YYYY")}
                          </dd>
                        </dl>
                        <dl className="col-md-4">
                          <dt>ACPT/REJ Date</dt>
                          <dd>
                            {offerLetterDetail.OfferLetterAcceptRejectDate
                              ? moment(
                                  offerLetterDetail.OfferLetterAcceptRejectDate
                                ).format("DD-MMM-YYYY")
                              : " "}
                          </dd>
                        </dl>
                        <dl className="col-md-4">
                          <dt>Status</dt>
                          <dd>{offerLetterDetail?.OfferLetterStatus}</dd>
                        </dl>
                      </div>
                      <div className="row">
                        <dl className="col-md-4">
                          <dt>Joining Date</dt>
                          <dd>{offerParameters["#emailJoiningDate#"]}</dd>
                        </dl>
                        <dl className="col-md-4">
                          <dt>Joining Location</dt>
                          <dd>{offerParameters["#emailJoiningLocation#"]}</dd>
                        </dl>
                      </div>
                    </div>
                    <div className="col-12">
                      <dl className="row">
                        <dt className="text-center">
                          <h4 className="text-decoration-underline">
                            Annexure 1
                          </h4>
                        </dt>
                        <dd className="col-12">
                          <div className="table-responsive">
                            <table className="table table-bordered table-striped">
                              <thead id="thcolor" className="text-center">
                                <tr>
                                  <td>
                                    <strong>Particulars</strong>
                                  </td>
                                  <td>
                                    <strong>Per Month</strong>
                                  </td>
                                  <td>
                                    <strong>Annual</strong>
                                  </td>
                                </tr>
                              </thead>
                              <tbody>
                                {displayableKeys.map((key) => {
                                  const value = offerParameters[key];

                                  if (key === "#AnnualPerformanceBonus#") {
                                    const grossSalary =
                                      offerParameters["#emailGrossSalary#"];
                                      const annualPerformanceBonus = (() => {
                                      const annualGrossSalary = parseFloat(offerParameters["#emailAnnualGrossSalary#"]) || 0;
                                      const abp = offerParameters["#emailABP#"];

                                      // If ABP is null or undefined, default to 10% of annualGrossSalary
                                      if (abp === null || abp === undefined) {
                                        return parseFloat((annualGrossSalary * 0.10).toFixed(2));
                                      }
                                      const offerLetterDate = moment(offerLetterDetail.OfferLetterSendDate);
                                      const staticDate = moment("2026-04-20", "YYYY-MM-DD");

                                      if (offerLetterDate.isBefore(staticDate, "day")) {
                                      // Otherwise, calculate based on ABP percentage
                                      return parseFloat(((annualGrossSalary * abp) / 100).toFixed(2));
                                      }
                                      else{
                                      return parseFloat(((grossSalary * abp) / 100).toFixed(2));
                                      }
                                      
                                    })();
                                    console.log(
                                      "annualPerformanceBonus",
                                      annualPerformanceBonus
                                    );

                                    return (
                                      <tr key={key}>
                                        <td>Annual Performance Bonus</td>
                                        <td style={{ textAlign: "right" }}>
                                          -
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {formatIndianNumber(
                                            Math.floor(annualPerformanceBonus)
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  }

                                  if (
                                    key === "#emailGrossSalary#" ||
                                    key === "#emailAnnualGrossSalary#"
                                  ) {
                                    const value = offerParameters[key];
                                    const values =
                                      offerParameters[
                                        "#emailAnnualGrossSalary#"
                                      ];
                                    return (
                                      <tr key={key}>
                                        <td>
                                          <strong>{formatKey(key)}</strong>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>
                                            {formatIndianNumber(value)}
                                          </strong>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>
                                            {formatIndianNumber(values)}
                                          </strong>
                                        </td>
                                      </tr>
                                    );
                                  }

                                  if (key === "#CTC#") {
                                    const annualGrossSalary =
                                      parseFloat(
                                        offerParameters[
                                          "#emailAnnualGrossSalary#"
                                        ]
                                      ) || 0;
                                    console.log(
                                      "annualGrossSalary",
                                      annualGrossSalary
                                    );

                                    const annualEPF =
                                      parseFloat(
                                        offerParameters["#emailAnnualEPF#"]
                                      ) || 0;
                                    console.log("annualEPF", annualEPF);
                                    const leaveEncashment =
                                      parseFloat(
                                        offerParameters[
                                          "#emailLeaveEncashment#"
                                        ]
                                      ) || 0;
                                    console.log(
                                      "leaveEncashment",
                                      leaveEncashment
                                    );
                                    const annualPerformanceBonus = (() => {
                                      const grossSalary = offerParameters["#emailGrossSalary#"];
                                      const annualGrossSalary = parseFloat(offerParameters["#emailAnnualGrossSalary#"]) || 0;
                                      const abp = offerParameters["#emailABP#"];

                                      // If ABP is null or undefined, default to 10% of annualGrossSalary
                                      if (abp === null || abp === undefined) {
                                        return parseFloat((annualGrossSalary * 0.10).toFixed(2));
                                      }
                                      const offerLetterDate = moment(offerLetterDetail.OfferLetterSendDate);
                                      const staticDate = moment("2026-04-20", "YYYY-MM-DD");
            
                                      

                                      if (offerLetterDate.isBefore(staticDate, "day"))  {
                                      // Otherwise, calculate based on ABP percentage
                                      return parseFloat(((annualGrossSalary * abp) / 100).toFixed(2));
                                      }
                                      else{
                                      return parseFloat(((grossSalary * abp) / 100).toFixed(2));
                                      }
                                      // Otherwise, calculate based on ABP percentage
                                      //return parseFloat(((annualGrossSalary * abp) / 100).toFixed(2));
                                    })();
                                    const annualGratuity =
                                      parseFloat(
                                        offerParameters["#emailAnnualGratuity#"]
                                      ) || 0;

                                    const mediclaimInsurance =
                                      parseFloat(
                                        offerParameters[
                                          "#emailMediclaimInsurance#"
                                        ]
                                      ) || 0;

                                    const ctc = (
                                      annualGrossSalary +
                                      annualEPF +
                                      leaveEncashment +
                                      annualPerformanceBonus +
                                      annualGratuity +
                                      mediclaimInsurance
                                    ).toFixed(2);
                                     
                                    return (
                                      <tr key={key}>
                                        <td>
                                          <strong>Total CTC</strong>
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          -
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          <strong>
                                            {formatIndianNumber(
                                              Math.floor(ctc)
                                            )}
                                          </strong>
                                        </td>
                                      </tr>
                                    );
                                  }
                                  if (key === "#emailMediclaimInsurance#") {
                                    const annualValue = value || "-";
                                    return (
                                      <tr key={key}>
                                        <td>{formatKey(key)}</td>
                                        <td style={{ textAlign: "right" }}>
                                          -
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {formatIndianNumber(annualValue)}
                                        </td>
                                      </tr>
                                    );
                                  }

                                  if (key === "#emailLeaveEncashment#") {
                                    const annualValue =
                                      offerParameters[key] || "-";
                                    return (
                                      <tr key={key}>
                                        <td>{formatKey(key)}</td>
                                        <td style={{ textAlign: "right" }}>
                                          -
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {formatIndianNumber(annualValue)}
                                        </td>
                                      </tr>
                                    );
                                  }

                                  if (key === "#emailGratuity#") {
                                    const annualValue =
                                      offerParameters[annualKeys[key]] || "-";
                                    return (
                                      <tr key={key}>
                                        <td>{formatKey(key)}</td>
                                        <td style={{ textAlign: "right" }}>
                                          -
                                        </td>
                                        <td style={{ textAlign: "right" }}>
                                          {formatIndianNumber(annualValue)}
                                        </td>
                                      </tr>
                                    );
                                  }
                                  if (key == "#emailNPS#") {
                                    const annualValue =
                                      offerParameters[annualKeys[key]] || "-";
                                    if (parseInt(offerParameters[key]) > 0) {
                                      return (
                                        <tr key={key}>
                                          <td>{formatKey(key)}</td>
                                          <td style={{ textAlign: "right" }}>
                                            {formatIndianNumber(
                                              offerParameters[key]
                                            )}
                                          </td>
                                          <td style={{ textAlign: "right" }}>
                                            {formatIndianNumber(annualValue)}
                                          </td>
                                        </tr>
                                      );
                                    } else {
                                      return <></>;
                                    }
                                  }

                                  const annualKey = annualKeys[key];
                                  const annualValue =
                                    offerParameters[annualKey] || "-";
                                  return (
                                    <tr key={key}>
                                      <td>{formatKey(key)}</td>
                                      <td style={{ textAlign: "right" }}>
                                        {formatIndianNumber(value) || "-"}
                                      </td>
                                      <td style={{ textAlign: "right" }}>
                                        {formatIndianNumber(annualValue)}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="custom-btn"
                  onClick={handleCloseModal}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* send reject email modal / popup */}
      <div
        className={`modal fade ${rejectemailModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: rejectemailModal ? "block" : "none" }}
        aria-modal="true"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div id="reject-email-modal">
              <div className="modal-header">
                <h5 className="modal-title">
                  <i class="bi bi-exclamation-triangle-fill email-send"></i>{" "}
                  <strong>Confirm</strong>
                </h5>
              </div>
              <div className="modal-body">
                <h6>Do you want to send rejection email to the candidate?</h6>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={closeModal}
                >
                  No
                </button>
                <button
                  type="button"
                  className="custom-btn"
                  onClick={() => sendRejectMail(id)}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal backdrop */}
      {rejectemailModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
};

export default CandidateHistoryView;
